import React, { useEffect, useRef, useState } from "react";
import { CalendarDays } from "lucide-react";

const toDmy = (iso) => (iso && /^\d{4}-\d{2}-\d{2}/.test(iso) ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : "");
const isValid = (iso) => { const d = new Date(`${iso}T00:00:00Z`); return !isNaN(d) && d.toISOString().slice(0, 10) === iso; };
const WRAP_RE = /^(?:[a-z]+:)?(?:w-|min-w-|max-w-|flex-|col-span|shrink|grow)/;

// Câmp de dată afișat mereu ZZ/LL/AAAA; valoarea rămâne ISO (AAAA-LL-ZZ), compatibil cu <input type="date">.
export function DateInput({ value, onChange, className = "", style, disabled, min, max, placeholder = "ZZ/LL/AAAA", onBlur, ...rest }) {
  const [text, setText] = useState(toDmy(value));
  const picker = useRef(null);
  useEffect(() => { setText(toDmy(value)); }, [value]);
  const emit = (iso) => onChange?.({ target: { value: iso }, currentTarget: { value: iso } });

  function handleType(e) {
    const raw = e.target.value.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) { setText(toDmy(raw)); if (isValid(raw)) emit(raw); return; }
    const v = raw.replace(/\D/g, "").slice(0, 8);
    setText(v.length > 4 ? `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4)}` : v.length > 2 ? `${v.slice(0, 2)}/${v.slice(2)}` : v);
    if (v.length === 8) {
      const iso = `${v.slice(4)}-${v.slice(2, 4)}-${v.slice(0, 2)}`;
      if (isValid(iso)) emit(iso);
    } else if (!v.length && value) emit("");
  }

  const cls = className.split(/\s+/);
  const wrapCls = cls.filter((c) => WRAP_RE.test(c)).join(" ");
  const inputCls = cls.filter((c) => !WRAP_RE.test(c)).join(" ");
  return (
    <span className={`relative inline-flex items-center ${wrapCls}`}>
      <input type="text" inputMode="numeric" autoComplete="off" value={text} placeholder={placeholder} disabled={disabled}
        onChange={handleType} onBlur={(e) => { setText(toDmy(value)); onBlur?.(e); }}
        className={`${inputCls} w-full pr-8`} style={style} {...rest} />
      <button type="button" tabIndex={-1} disabled={disabled} aria-label="Alege data"
        onClick={() => { try { picker.current?.showPicker(); } catch (_) { picker.current?.focus(); } }}
        className="absolute right-2 text-neutral-400 hover:text-brand disabled:opacity-40 bg-transparent">
        <CalendarDays className="h-4 w-4" />
      </button>
      <input ref={picker} type="date" tabIndex={-1} aria-hidden="true" value={value || ""} min={min} max={max}
        onChange={(e) => emit(e.target.value)} className="absolute left-0 bottom-0 w-px h-px opacity-0 pointer-events-none" />
    </span>
  );
}
